// Meta de MARGEM do cadastro (indices financeiros, Fase 1 — migration 0300).
//
// A regua e' o MARKUP sobre o custo, a mesma do "Mrg Pix" do cadastro e da planilha "Composicao de
// Preco" dele ([DA-643]): (pix - custo) / custo. NAO e' margem sobre a venda — 73% de markup deixa
// 42% do preco. A margem sobre a venda (e a liquida) nasce com nome proprio na Fase 2, pra as duas
// nunca dividirem o mesmo rotulo.
//
// A meta de um produto e' a da CATEGORIA dele; sem meta na categoria (ou sem categoria — 895 dos
// 1.508 ativos em 26/09/2026), vale a meta padrao da loja. Uma funcao so pra tela e servidor
// decidirem "abaixo da meta" do mesmo jeito.

/** Markup sobre o custo, em %. `null` quando nao ha custo — sem custo nao existe margem a medir. */
export function markupSobreCusto(pix: number | string | null | undefined, custo: number | string | null | undefined): number | null {
  const c = Number(custo || 0);
  if (!Number.isFinite(c) || c <= 0) return null;
  const v = Number(pix || 0);
  if (!Number.isFinite(v)) return null;
  return ((v - c) / c) * 100;
}

/** A meta que vale pro produto: a da categoria quando existe, senao a padrao da loja. */
export function metaMarkupEfetiva(metaCategoria: number | string | null | undefined, metaPadrao: number): number {
  if (metaCategoria === null || metaCategoria === undefined || metaCategoria === '') return metaPadrao;
  const m = Number(metaCategoria);
  return Number.isFinite(m) ? m : metaPadrao;
}

/**
 * Abaixo da meta? Produto SEM custo nunca esta "abaixo" — ele cai no outro balde ("sem custo"),
 * porque o problema dele e' o cadastro, nao o preco. A comparacao e' em centesimos de ponto
 * percentual pra 29,999...% (float de 1,30 x custo) nao virar "abaixo de 30".
 */
export function abaixoDaMeta(pix: number | string | null | undefined, custo: number | string | null | undefined, meta: number): boolean {
  const mk = markupSobreCusto(pix, custo);
  if (mk === null) return false;
  return Math.round(mk * 100) < Math.round(meta * 100);
}

/**
 * Le a meta digitada ("30", "25,5", "") pra gravar. Vazio = `null` (a categoria volta a seguir a
 * padrao). Recusa (undefined) o que nao e' numero, negativo ou acima de 1000%.
 */
export function parseMetaMarkup(valor: string | number | null | undefined): number | null | undefined {
  if (valor === null || valor === undefined) return null;
  const s = String(valor).trim().replace('%', '').replace(',', '.');
  if (s === '') return null;
  const n = Number(s);
  if (!Number.isFinite(n) || n < 0 || n > 1000) return undefined;
  return Math.round(n * 100) / 100;
}
